// @ts-nocheck
/**
 * Maison Faubourg Paris — Animations éditoriales
 * IntersectionObserver + classes CSS (mfp-animations.css)
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const EXCLUSIONS = [
    'header', 'footer', '.mfp-cinematic-entry',
    '.product-form', 'form[action^="/cart/add"]', 'form[action^="/checkout"]',
    '.price', '.quantity', '.shopify-payment-button',
    '.cart-totals', '.cart__checkout-button', '.cart-drawer', '.drawer',
    '.modal', '.search-modal', '.predictive-search',
    '.sticky', '.sticky-add-to-cart',
    '[aria-live]', '[hidden]', '.product__media-list',
    '[data-testid="sticky-price-display"]'
  ];
  const EXCLUSION_SELECTOR = EXCLUSIONS.join(', ');

  function isExcluded(el) {
    return !!el.closest(EXCLUSION_SELECTOR);
  }

  function getEls(selectors) {
    return Array.from(document.querySelectorAll(selectors.join(', '))).filter(el => {
      if (isExcluded(el)) return false;
      if (el.tagName.toLowerCase() !== 'img' && el.textContent.trim().length === 0) return false;
      return true;
    });
  }

  const SEL = {
    title: [
      '#MainContent h1', '#MainContent h2', '#MainContent h3',
      '.mf-hero__title', '.mf-maison__title', '.mf-icon__title',
      '.mf-detail__title', '.mf-ambiances__title', '.mf-service__title',
      '.mf-engagements__title', '.mf-footer__title',
      '.mf-service__block-title', '.mf-detail__block-title',
      '.mf-ambiances__caption-title'
    ],
    text: [
      '#MainContent p', '#MainContent .rte', '#MainContent li',
      '.mf-maison__text', '.mf-icon__desc', '.mf-detail__subtitle',
      '.mf-detail__block-text', '.mf-ambiances__subtitle',
      '.mf-ambiances__caption-text', '.mf-service__block-text',
      '.mf-engagements__text', '.mf-manifeste__text'
    ],
    image: [
      '.mf-hero__image-wrapper', '.mf-maison__image-wrapper',
      '.mf-icon__image-col', '.mf-detail__image-wrapper',
      '.mf-ambiances__image-wrapper', '.mf-engagements__image-wrapper',
      '#MainContent figure:not(.product-card figure)'
    ],
    card: [
      '#MainContent article', '#MainContent .card',
      '#MainContent .product-card', '#MainContent .collection-card',
      '#MainContent product-card'
    ],
    btn: [
      '#MainContent a.button', '#MainContent a.btn',
      '#MainContent button:not(.product-form__submit):not([name="add"]):not([name="checkout"])',
      '.mf-hero__btn', '.mf-maison__button', '.mf-icon__btn',
      '.mf-service__button', '.mf-engagements__button', '.mf-footer__submit'
    ],
    line: ['.mf-divider', '.mfp-anim-line', '.mf-section__line']
  };

  function init() {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mfp-anim-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    const classMap = {
      title: 'mfp-anim-title',
      text:  'mfp-anim-text',
      image: 'mfp-anim-image',
      card:  'mfp-anim-card',
      btn:   'mfp-anim-btn',
      line:  'mfp-anim-line'
    };

    Object.entries(classMap).forEach(([key, cls]) => {
      getEls(SEL[key]).forEach(el => {
        if (key === 'title' && !el.querySelector('div, ul, li, img')) {
          if (!el.querySelector('.mfp-anim-title-inner')) {
            el.innerHTML = `<span class="mfp-anim-title-inner">${el.innerHTML}</span>`;
          }
        }
        el.classList.add(cls);
        observer.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      'requestIdleCallback' in window ? requestIdleCallback(init) : setTimeout(init, 50);
    });
  } else {
    'requestIdleCallback' in window ? requestIdleCallback(init) : setTimeout(init, 50);
  }
})();
